module.exports = __webpack_public_path__ + "static/media/011-asterisk.d36613c3.svg";